<template>
  <header class="sticky top-0 z-50 backdrop-blur-sm">
    <!-- Top Bar (Primary Nav) -->
    <div class="bg-primary-600/95 backdrop-blur-sm text-white py-3 px-4 shadow-lg border-b border-primary-500/20">
      <div class="max-w-7xl mx-auto flex items-center justify-between">
        <div class="flex items-center">
          <router-link to="/" class="transition-transform duration-200 hover:scale-105">
            <TopLogo />
          </router-link>
        </div>
        <ul class="hidden md:flex items-center space-x-6 list-none m-0 p-0">
          <NavItem v-for="(item, index) in primaryNavItems" :key="index" :label="item.label" :link="item.link" />
        </ul>
        <!-- Mobile menu button (can be implemented later) -->
        <div class="md:hidden">
          <button class="text-white hover:text-gray-200 transition-colors">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <!-- Secondary nav can be added later if needed -->
  </header>
</template>

<script setup>
  import { computed } from 'vue';
  import TopLogo from '@/components/Header/TopLogo.vue';
  import NavItem from '@/components/Common/NavItem.vue';
  import sectionsData from '@/data/sections.json';

  // Generate primary nav items from sectionsData; prepend "Home".
  const primaryNavItems = computed(() => {
    const items = [{ label: 'Home', link: '/' }];
    sectionsData.forEach((section) => {
      // Use the topNavItem from sectionsData and create a dynamic route
      items.push({
        label: section.topNavItem,
        link: `/theme/${section.topNavItem}`,
      });
    });
    return items;
  });
</script>

<style scoped>
  /* Custom styles for components that need specific styling beyond Tailwind classes */
</style>
